var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#002D4E","fillRule":"evenodd","d":"M6.68 0l6.68 6.68-6.68 6.68-1.18-1.18 4.66-4.68H0V5.86h10.16L5.5 1.18z"}));
}

Arrow.defaultProps = {"viewBox":"0 0 14 14"};

module.exports = Arrow;

Arrow.default = Arrow;
